import { AfterViewInit,Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { Select2Data, Select2UpdateEvent, Select2SearchEvent, Select2ScrollEvent, } from 'ng-select2-component';
import { StorageService } from '../../services/storage.service';
import { StorageName } from '../../enum/common-enum';
import { catchError, Subscription } from 'rxjs';


@Component({
  selector: 'app-custom-select2',
  templateUrl: './custom-select2.component.html',
  styleUrls: ['./custom-select2.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CustomSelect2Component implements OnInit , AfterViewInit{
  getInvoiceSubscription: Subscription;
  getAllDropdownModel : any = {};
  storageName = StorageName;
  dropdown: any[] = [];
  id: any;
  data3: Select2Data = [];
  overlay = false;
  searchSelectedName:string;
  private debounceTimer: any;
  highlightedIndex: number = -1;
  newLedger: any;
  @Input() placeholder:any;
  @Input() formModel: any;      
  @Input() displayText: string;
  @Input() selec2: string;
  @Input() selectedValue: any;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() keyEnter: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('select2Ref') select2Ref: any; 
  @Input() whichDropdown = StorageName.ACCOUNTLEDGER_DROPDOWN;
  @Input() isAllowedAddSearchTextInList: boolean=true;
  @Input() isDropdownOpen: boolean = false;
  @ViewChild('select2Container', { static: false }) select2Container!: ElementRef;
  @Input() customId : string;
  @Input() hideAlternateName: boolean = false;
  @Input() headerLabel : any = {};
  @Input() dropdownMandatory = false;
  constructor(public storageService: StorageService, private renderer: Renderer2, private el: ElementRef ) {
    this.getInvoiceSubscription = this.storageService.setSelect2Dropdown.subscribe((result) => {
      if (result != undefined) {
        this.getInvoiceResponse(result);
      }
    });
  }

  onEnterPressed(event) {
    this.keyEnter.emit();
  }

  onDropdownOpened(event) {
    // Focus on the first item in the dropdown
    const options = document.querySelectorAll('.select2-results__option');
    const event2 = new MouseEvent('mouseenter', {
      bubbles: true,
      cancelable: true,
      view: window
    });
    if (options.length > 0)
      options[0].dispatchEvent(event2);
  }

//#region Assign Col Name in Dropdown
  ngAfterViewInit() {
    if (this.isDropdownOpen && this.select2Container) {
      setTimeout(() => {
        this.openDropdown();
      }, 100); 
    }
    const targetDiv = this.el.nativeElement.querySelector('.select2-results');
    this.select2Ref.open.subscribe(res => {
      this.onDropdownOpened('opened')
    })
    this.highlightedIndex = -1;
    if (targetDiv) {
      const newDiv = this.renderer.createElement('div');
      if(this.whichDropdown == StorageName.ACCOUNTLEDGER_DROPDOWN){
      newDiv.innerHTML = `
        <div class="template_header">
          <div class="row mx-0">
            <div class="col-8 ps-1 text-truncate">Name</div>
            <div class="col-4 pe-0 ps-0 text-truncate">Contact</div>
          </div>
        </div>
      `;
      }else if (this.whichDropdown === StorageName.PRODUCT_DROPDOWN) {
        newDiv.innerHTML = `
        <div class="template_header">
          <div class="row mx-0">
            <div class="col-8 ps-1 text-truncate">Name</div>
            ${!this.hideAlternateName ? `<div class="col-4 pe-0 ps-0 text-truncate">Contact</div>` : ''}
          </div>
        </div>
      `;
      }      
      else if(this.whichDropdown == StorageName.SALEPERSON_DROPDOWN){
        newDiv.innerHTML = `
        <div class="template_header">
          <div class="row mx-0">
            <div class="col-12 px-1 text-truncate">Sale Person</div>
          </div>
        </div>
      `;
      }
      else if(this.whichDropdown == StorageName.INVOICE_NO_DROPDOWN){
        newDiv.innerHTML = `
        <div class="template_header">
          <div class="row mx-0">
            <div class="col-12 px-1 text-truncate">Invoice No.</div>
          </div>
        </div>
      `;
      }
      else if(this.whichDropdown == StorageName.PURCHASEINVOICENO_DROPDOWN){
        newDiv.innerHTML = `
        <div class="template_header">
          <div class="row mx-0">
            <div class="col-12 px-1 text-truncate">Purchase Invoice No</div>
          </div>
        </div>
      `;
      }
      else if(this.whichDropdown == StorageName.SALEORDERPROCESS_BARCODENO_DROPDOWN){
        newDiv.innerHTML = `
        <div class="template_header">
          <div class="row mx-0">
            <div class="col-12 px-1 text-truncate">Tag No</div>
          </div>
        </div>
      `;
      }
      else if(this.whichDropdown == StorageName.ALL_ACCOUNTLEDGER_DROPDOWN){
        newDiv.innerHTML = `
        <div class="template_header">
          <div class="row mx-0">
            <div class="col-8 ps-1 text-truncate">Name</div>
            <div class="col-4 pe-0 ps-0 text-truncate">Contact</div>
          </div>
        </div>
      `;
      }
      else if(this.whichDropdown == StorageName.DESIGN_NO_DROPDOWN){
        newDiv.innerHTML = `
        <div class="template_header">
          <div class="row mx-0">
            <div class="col-8 ps-1 text-truncate">Design No</div>
          </div>
        </div>
      `;
      }
      else if(this.whichDropdown == StorageName.SCHEME_NAME_DROPDOWN){
        newDiv.innerHTML = `
        <div class="template_header">
          <div class="row mx-0">
            <div class="col-8 ps-1 text-truncate">Name</div>
          </div>
        </div>
      `;
      }
      else if(this.whichDropdown == StorageName.ACCOUNTGROUP_DROPDOWN){
        newDiv.innerHTML = `
        <div class="template_header">
          <div class="row mx-0">
            <div class="col-8 ps-1 text-truncate">Name</div>
          </div>
        </div>
      `;
      }
      else if(this.whichDropdown == StorageName.CATEGORY_DROPDOWN){
        newDiv.innerHTML = `
        <div class="template_header">
          <div class="row mx-0">
            <div class="col-8 ps-1 text-truncate">Name</div>
          </div>
        </div>
      `;
      }
      else if(this.whichDropdown == StorageName.COUNTRY_DROPDOWN){
        newDiv.innerHTML = `
        <div class="template_header">
          <div class="row mx-0">
            <div class="col-8 ps-1 text-truncate">Name</div>
          </div>
        </div>
      `;
      }
      else if(this.whichDropdown == StorageName.VOUCHER_TYPE_DROPDOWN){
        newDiv.innerHTML = `
        <div class="template_header">
          <div class="row mx-0">
            <div class="col-8 ps-1 text-truncate">Name</div>
          </div>
        </div>
      `;
      }
      else if(this.whichDropdown == StorageName.BAUD_DROPDOWN){
        newDiv.innerHTML = `
        <div class="template_header">
          <div class="row mx-0">
            <div class="col-8 ps-1 text-truncate">Name</div>
          </div>
        </div>
      `;
      }
      else if(this.whichDropdown == StorageName.STATE_DROPDOWN){
        newDiv.innerHTML = `
        <div class="template_header">
          <div class="row mx-0">
            <div class="col-8 ps-1 text-truncate">Name</div>
          </div>
        </div>
      `;
      }
      else if(this.whichDropdown == StorageName.BRANCH_DROPDOWN){
        newDiv.innerHTML = `
        <div class="template_header">
          <div class="row mx-0">
            <div class="col-8 ps-1 text-truncate">Name</div>
          </div>
        </div>
      `;
      }
      else if(this.whichDropdown == StorageName.DIALCODE_DROPDOWN || this.whichDropdown == StorageName.COUNTRY_CODE_AND_NAME_DROPDOWN){
        newDiv.innerHTML = `
        <div class="template_header">
          <div class="ps-1 text-truncate">Dial Code</div>
        </div>
      `;
      }
      this.renderer.insertBefore(targetDiv, newDiv, targetDiv.firstChild);
    }
    this.addEnterKeydownListener('select2-search__field', (event) => {
       this.onKeydown(event);
    });
  }
//#endregion Assign Col Name in Dropdown

//#region For Invoice No Dropdown Toggle Functionality
  openDropdown(): void {
    if (this.select2Container) {
      const container = this.select2Container?.nativeElement?.querySelector('.select2-selection');
      if (container) {
        container.click();
      }
    }
  }
//#endregion For Invoice No Dropdown Toggle Functionality

//#region For Assign Dropdown Data
  setDataSource(datasorce ,newCreatedOptionId?): void {
    this.dropdown = datasorce;

    this.data3 = this.dropdown as Select2Data;

    if(this.whichDropdown === StorageName.ACCOUNTLEDGER_DROPDOWN){
      try
      {
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-8 pe-0 text-truncate">' + item.name + '</div>' +
          '<div class="col-4 pe-0">' +  JSON.parse(item.extra2)[0]?.contactNo + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }catch
    {
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-8 pe-0 text-truncate">' + item.name + '</div>' +
          '<div class="col-4 pe-0"></div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    }
    else if(this.whichDropdown === StorageName.PRODUCT_DROPDOWN){
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: `<div class="select2-multiple-labels">
          <div class="row">
            <div class="col-8 pe-0 text-truncate">${item.name}</div>
            ${!this.hideAlternateName ? `<div class="col-4 pe-0 ps-4 text-truncate">${item.extra3}</div>` : ''}
          </div>
        </div>
      `
      })) as Select2Data;
    }
    else if(this.whichDropdown === StorageName.SALEPERSON_DROPDOWN){
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-12 pe-0 text-truncate">' + item.name + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if(this.whichDropdown === StorageName.INVOICE_NO_DROPDOWN){
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="">' +
          '<div class="">' +
          '<div class="col-12 pe-0 text-truncate">' + item.name + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if(this.whichDropdown === StorageName.PURCHASEINVOICENO_DROPDOWN){
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-12 pe-0 text-truncate">' + item.name + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if(this.whichDropdown === StorageName.SALEORDERPROCESS_BARCODENO_DROPDOWN){
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-12 pe-0 text-truncate">' + item.name + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if(this.whichDropdown === StorageName.ALL_ACCOUNTLEDGER_DROPDOWN){
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-8 pe-0 text-truncate">' + item.name + '</div>' +
          '<div class="col-4 pe-0">' + item.extra2 + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if(this.whichDropdown === StorageName.DESIGN_NO_DROPDOWN){
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-8 pe-0 text-truncate">' + item.name + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if(this.whichDropdown === StorageName.SCHEME_NAME_DROPDOWN){
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-8 pe-0 text-truncate">' + item.name + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if(this.whichDropdown === StorageName.ACCOUNTGROUP_DROPDOWN){
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-8 pe-0 text-truncate">' + item.name + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if (this.whichDropdown == StorageName.VOUCHER_TYPE_DROPDOWN) {
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-8 pe-0 text-truncate">' + item.name + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if(this.whichDropdown == StorageName.CATEGORY_DROPDOWN){
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-8 pe-0 text-truncate">' + item.name + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if(this.whichDropdown == StorageName.COUNTRY_DROPDOWN){
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-8 pe-0 text-truncate">' + item.name + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if (this.whichDropdown === StorageName.AGAINST_DROPDOWN) {
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-8 pe-0 text-truncate">' + item.name + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if (this.whichDropdown === StorageName.BAUD_DROPDOWN) {
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-8 pe-0 text-truncate">' + item.name + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if (this.whichDropdown === StorageName.STATE_DROPDOWN) {
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-8 pe-0 text-truncate">' + item.name + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if (this.whichDropdown === StorageName.DIALCODE_DROPDOWN) {
      this.data3 = this.dropdown?.map(item => ({
        value: item.extra1,
        label: '<div class="select2-multiple-labels">' +
        '<div class="">' + item.name + '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if(this.whichDropdown == StorageName.COUNTRY_NAME_DROPDOWN){
      this.data3 = this.dropdown?.map(item => ({
        value: item.dialCode,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-8 pe-0 text-truncate">' + item.countryName + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if (this.whichDropdown === StorageName.COUNTRY_CODE_AND_NAME_DROPDOWN) {
      this.data3 = this.dropdown?.map(item => ({
        value: item.dialCode,
        label: '<div class="select2-multiple-labels">' +
        '<div class="">' + item.dialCode + '</div>' +
          '</div>'
      })) as Select2Data;
    }
    else if (this.whichDropdown === StorageName.BRANCH_DROPDOWN) {
      this.dropdownMandatory = true;
      this.data3 = this.dropdown?.map(item => ({
        value: item.id,
        label: '<div class="select2-multiple-labels">' +
          '<div class="row">' +
          '<div class="col-8 pe-0 text-truncate">' + item.name + '</div>' +
          '</div>' +
          '</div>'
      })) as Select2Data;
    }
    if(!(this.dropdownMandatory)){
      if(this.data3)this.data3 = [{ value: '',label: ''},...this.data3,];  // For adding empty row in dropdown list.
    }
    
    if(this.whichDropdown === StorageName.ACCOUNTLEDGER_DROPDOWN){
      this.id = this.formModel?.invoiceModel?.accountLedgerId;
    }
    if(newCreatedOptionId) {
      this.setDropdownText(newCreatedOptionId)
    }
  }
//#endregion For Assign Dropdown Data

  ngOnInit() {
     this.storageService.customDropdownValue.subscribe((res=>{
      if(res){
         const newLedger = this.data3?.find((x) => x?.label?.includes(res && '\n' ));
         if(newLedger == undefined) return
         this.select2Ref.reset();
         this.data3 = this.data3?.filter((x) => x !== newLedger);
      }
    }))
  }

  getInvoiceResponse(result) {
    this.setDropdownText(result);
  }

  setNewLedgerName(newLedger: any) {
    this.newLedger = newLedger;
  }

  update(key: string, event: Select2UpdateEvent<any>,customId) {
    this[key] = event.value;
  
    const searchText = (this.newLedger || event.component.searchText || '').toLowerCase();
  
    if (searchText && this.isAllowedAddSearchTextInList) {
      const existsInDropdown = this.dropdown.some(x =>
        x?.name?.toLowerCase()?.includes(searchText)
      );
  
      const existsInData3 = this.data3.some(x =>
        (typeof x.label === 'string' ? x.label : '')?.toLowerCase()?.includes(searchText)
      );
  
      if (!existsInDropdown && !existsInData3) {
        const newEntry = {
          value: this.data3.length,
          label: `
            <div class="select2-multiple-labels">
              <div class="row">
                <div class="col-8 pe-0 text-truncate">${event.component.searchText}</div>
                <div class="col-4 pe-0"></div>
              </div>
            </div>`
        };
  
        this.data3.push(newEntry);
        this.setDropdownText(newEntry.value);
        this.valueChanged.emit(newEntry.value);
      } else {
        this.setDropdownText(event.value);
        this.valueChanged.emit(event.value);
      }
    } else {
      this.setDropdownText(event.value);
      this.valueChanged.emit(event.value);
    }
  
    // #region Show Title on Hover
    this.updateTooltip(customId);
    // #endregion
  }
  

// method for updating tooltip
private updateTooltip(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
        const renderedElement = element.querySelector('.select2-selection__rendered');
        if (renderedElement) {
            setTimeout(() => {
                const htmlString = renderedElement.getAttribute('title');
                if (htmlString) {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = htmlString;
                    const name = tempDiv.querySelector('.col-8.pe-0.text-truncate')?.textContent;
                    const phoneNumber = tempDiv.querySelector('.col-4.pe-0')?.textContent;
                    const combineTitle = `Name: ${name ?? 'NA'}, Contact: ${phoneNumber ?? 'NA'}`;
                    renderedElement.setAttribute('title', combineTitle);
                }
            }, 300);
        }
    }
}

  setDropdownText(value) {
    this.id = value;
  }
  
  reset(){
    this.select2Ref?.reset();
    const searchElement = document.getElementById('selec2-2-search-field') as HTMLInputElement | null;
    if(searchElement) searchElement.value ='';
  }

  search(key: string, event: Select2SearchEvent) {
    event.filteredData(
      event.search
        ? event.data.filter(option => option.label.toLowerCase().includes(event.search.toLowerCase()))
        : event.data,
    );
  }

  onKeydown(event: KeyboardEvent): void {
    const target = event.target as HTMLInputElement;
    if (event.key === 'Enter') {
      this.select2Ref?.toggleOpenAndClose(false, false);
      this.focusOnMatchingOption(target.value);
      if(this.isDropdownOpen)
      this.valueChanged.emit(target.value);
    }

  }


  focusOnMatchingOption(searchKey: string) {
    if (this.select2Ref && this.select2Ref.filteredData) {
      const matchingOption: any = this.select2Ref.filteredData.find(option => {
        const label = option?.label?.toString()?.toLowerCase();
        return label?.includes(searchKey?.toLowerCase());
      });
      if (matchingOption) {
        if (this.select2Ref.filteredData.length === 1) {
          this.setDropdownText(matchingOption.value);
          this.valueChanged.emit(matchingOption.value);
        }
      } else {
        this.keyEnter.emit(searchKey);
      }
    }
  }
  

  addEnterKeydownListener(className: string, callback: (event: KeyboardEvent) => void) {
    const elements = document.querySelectorAll('.' + className);
    elements.forEach((element: HTMLElement) => {
      const listener = this.renderer.listen(element, 'keydown', (event) => {
        if (event.key === 'Enter') {
          clearTimeout(this.debounceTimer);
          this.debounceTimer = setTimeout(() => {
            callback(event);
          }, 300); // Adjust the debounce delay as needed
        }
      });
    });
  }


  handleKeyDown(event: KeyboardEvent,id): void {
    const select2Element = document?.getElementById(id);
    const highlightedOptions = select2Element?.querySelectorAll('.select2-results__option--highlighted');
    if (highlightedOptions?.length > 0) {
      // Scroll the first highlighted option into view
      const entryDownKeyScroll = highlightedOptions[0] as HTMLElement;
      entryDownKeyScroll.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    } else {
      this.onDropdownOpened('opened');
    }
  }
  

  ngOnDestroy() {
    this.getInvoiceSubscription?.unsubscribe();
  }

  
}

